/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductLcasQueryResponse,
  FindProductLcasQueryParams,
} from "../types/FindProductLcas.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductLcasQueryKey = (params?: FindProductLcasQueryParams) =>
  [{ url: "/v1/lca/find-product-lcas" }, ...(params ? [params] : [])] as const

export type FindProductLcasQueryKey = ReturnType<typeof findProductLcasQueryKey>

/**
 * {@link /v1/lca/find-product-lcas}
 */
export async function findProductLcas(
  params?: FindProductLcasQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductLcasQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/lca/find-product-lcas`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductLcasQueryOptions(
  params?: FindProductLcasQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductLcasQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductLcasQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductLcasQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductLcas(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * {@link /v1/lca/find-product-lcas}
 */
export function useFindProductLcas<
  TData = ResponseConfig<FindProductLcasQueryResponse>,
  TQueryData = ResponseConfig<FindProductLcasQueryResponse>,
  TQueryKey extends QueryKey = FindProductLcasQueryKey,
>(
  params?: FindProductLcasQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductLcasQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findProductLcasQueryKey(params)

  const query = useQuery(
    {
      ...findProductLcasQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
